module.exports = __webpack_public_path__ + "img/zone200400.6750ef23.png";